import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex bg-[#121212] overflow-hidden select-none">
      {/* Left side - Auth forms */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-32 bg-[#1E1E1E] relative z-10 lg:rounded-r-[3rem] lg:border-r lg:border-[#51107E]/40 lg:shadow-[12px_0_60px_rgba(0,0,0,0.85)] lg:border-t lg:border-t-[#F3227D]/50 transition-all duration-300">
        <div className="mx-auto w-full max-w-sm lg:w-96 animate-fade-in">
          {/* Auth form content */}
          <Outlet />
        </div>
      </div>

      {/* Right side - Decorative */}
      <div className="hidden lg:block relative w-0 flex-1 bg-[#000000]">
        {/* Subtle background glow layers */}
        <div className="absolute inset-0 h-full w-full bg-gradient-to-tr from-[#6F239B]/20 via-[#000000] to-[#F3227D]/10 z-10 pointer-events-none mix-blend-color-dodge" />
        <div className="absolute inset-0 h-full w-full bg-radial-gradient from-transparent to-[#121212]/90 z-10 pointer-events-none" />

        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/login.png"
            alt="MST-MINT Branding"
            className="h-full w-full object-cover object-right opacity-80 select-none pointer-events-none transition-all duration-700 hover:scale-[1.02] hover:opacity-95"
          />
        </div>
      </div>
    </div>
  );
}
